class FocalPrecision {

    /**
     * @since 4.18.0
     * @method constructor
     */
    constructor() {
        // Declare and initialize
        this.selector = '[style*="--focus-point-x"], [style*="--focus-point-y"]';
        this.flood;

        // Run initialization
        this.init();
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 4.18.0
     * @returns void
     */
    init() {
        // If there are no elements, bail
        if (!$(this.selector).length) return;

        // Update once assets are loaded
        $(this.selector).each((i, ele) => {

            // Declare and initialize
            let $wrap  = $(ele);
            let $media = this.getMedia($wrap);

            // If no media is found, bail
            if (!$media.length) return;

            // If already loaded, update
            if (this.isLoaded($media))
                this.update($wrap, $media);
            else
                this.bindLoad($media, () => this.update($wrap, $media));

        });

        // Listen for window resize
        $(window).on('resize', () => {

            // If the flood gate is opened, close it
            if (this.flood)
                clearTimeout(this.flood);

            // Open a time-delay floodgate
            this.flood = setTimeout(() => this.updateAll(), 5);

        });

        // Run it one time when the page loads
        this.flood = setTimeout(() => this.updateAll(), 5);

        // Prevent leaks
        return;
    }

    /**
     * Update all focal-cover elements.
     *
     * @since 4.18.0
     * @method updateAll
     * @returns void
     */
    updateAll() {

        // Update each element
        $(this.selector).each((i, ele) => {

            // Declare and initialize
            let $wrap  = $(ele);
            let $media = this.getMedia($wrap);

            // If no media is found, bail
            if (!$media.length) return;

            // Update
            this.update($wrap, $media);

        });

    }

    /**
     * Get the media element for a wrapper:
     * - If wrapper itself is img/video, use it
     * - Else use the first nested img/video
     *
     * @since 4.18.0
     * @method getMedia
     * @param object $wrap is the wrapper element
     * @returns object
     */
    getMedia($wrap) {

        // If wrap is the media, return it
        if ($wrap.is('img, video'))
            return $wrap;

        // Otherwise find the nested media
        return $wrap.find('img, video').first();
    }

    /**
     * Determine whether the media element is loaded enough for sizing.
     *
     * @since 4.18.0
     * @method isLoaded
     * @param object $media is the media element
     * @returns bool
     */
    isLoaded($media) {

        // Declare and initialize
        var media = $media.get(0);

        // If invalid, bail
        if (!media) return false;

        // Images
        if ('IMG' === media.tagName)
            return !!(media.complete && media.naturalWidth);

        // Videos
        if ('VIDEO' === media.tagName)
            return !!(media.videoWidth && media.videoHeight);

        // Fallback
        return false;
    }

    /**
     * Bind an appropriate load event for the media element.
     *
     * @since 4.18.0
     * @method bindLoad
     * @param object $media is the media element
     * @param function cb is the callback
     * @returns void
     */
    bindLoad($media, cb) {

        // Declare and initialize
        var media = $media.get(0);

        // If invalid, bail
        if (!media) return;

        // Images
        if ('IMG' === media.tagName) {
            $media.one('load', cb);
            return;
        }

        // Videos (metadata is enough for dimensions)
        if ('VIDEO' === media.tagName) {
            $media.one('loadedmetadata', cb);
            return;
        }

        // Prevent leaks
        return;
    }

    /**
     * Read and normalize a CSS variable value into 0..1.
     *
     * Accepts:
     * - "0.23"
     * - "23%"
     *
     * @since 4.18.0
     * @method parseVar
     * @param string value is the raw CSS variable value
     * @param float fallback is the fallback if parsing fails
     * @returns float
     */
    parseVar(value, fallback) {

        // Declare and initialize
        var v = (value || '').toString().trim();

        // If empty, return fallback
        if (!v.length) return fallback;

        // Percent form
        if (v.includes('%'))
            v = parseFloat(v) / 100;
        else
            v = parseFloat(v);

        // If invalid, return fallback
        if (isNaN(v)) return fallback;

        // Clamp
        v = Math.min(1, Math.max(0, v));

        // That's all, folks
        return v;
    }

    /**
     * Cache the original focus-point values (once) from the wrapper element.
     *
     * @since 4.18.0
     * @method cacheOriginal
     * @param object $wrap is the wrapper element that holds the CSS vars
     * @returns void
     */
    cacheOriginal($wrap) {

        // If already cached, bail
        if (undefined !== $wrap.data('focus-point-x-orig') && undefined !== $wrap.data('focus-point-y-orig'))
            return;

        // Declare and initialize
        var wrap   = $wrap.get(0);
        var styles = window.getComputedStyle(wrap);
        var rawX   = styles.getPropertyValue('--focus-point-x');
        var rawY   = styles.getPropertyValue('--focus-point-y');
        var fx     = this.parseVar(rawX, 0.5);
        var fy     = this.parseVar(rawY, 0.5);

        // Cache originals as 0..1 floats
        $wrap.data('focus-point-x-orig', fx);
        $wrap.data('focus-point-y-orig', fy);

        // Prevent leaks
        return;
    }

    /**
     * Compute and apply new --focus-point-x/y on the WRAPPER element,
     * but compute cover math using the MEDIA element's box (critical).
     *
     * @since 4.18.0
     * @method update
     * @param object $wrap is the wrapper element that holds the CSS vars
     * @param object $media is the img/video element being displayed
     * @returns void
     */
    update($wrap, $media) {

        // Declare and initialize
        var wrap  = $wrap.get(0);
        var media = $media.get(0);

        // If invalid, bail
        if (!wrap || !media) return;

        // Cache original focus points once (on wrapper)
        this.cacheOriginal($wrap);

        // Read cached originals (0..1)
        var fx = parseFloat($wrap.data('focus-point-x-orig'));
        var fy = parseFloat($wrap.data('focus-point-y-orig'));

        // Defaults
        if (isNaN(fx)) fx = 0.5;
        if (isNaN(fy)) fy = 0.5;

        // MEDIA box (this is what object-position actually uses)
        var cw = media.clientWidth;
        var ch = media.clientHeight;

        // Intrinsic media size
        var iw = 0;
        var ih = 0;

        // We use different widths based on media
        if ('IMG' === media.tagName) {
            iw = media.naturalWidth;
            ih = media.naturalHeight;
        } else if ('VIDEO' === media.tagName) {
            iw = media.videoWidth;
            ih = media.videoHeight;
        }

        // If not measurable yet, bail
        if (!cw || !ch || !iw || !ih) return;

        // object-fit: cover scale
        var scale = Math.max(cw / iw, ch / ih);

        // Scaled media dimensions
        var sw = iw * scale;
        var sh = ih * scale;

        // Focal point in scaled pixels
        var fpx = fx * sw;
        var fpy = fy * sh;

        // Desired offsets to put focal at center
        var left = (cw / 2) - fpx;
        var top  = (ch / 2) - fpy;

        // Clamp offsets (cover cannot reveal outside media bounds)
        var minLeft = cw - sw;
        var maxLeft = 0;
        var minTop  = ch - sh;
        var maxTop  = 0;

        // Clamp horizontal offsets
        if (left < minLeft) left = minLeft;
        if (left > maxLeft) left = maxLeft;

        // Clamp vertical offsets
        if (top < minTop) top = minTop;
        if (top > maxTop) top = maxTop;

        // Convert offsets to alignment factors (0..1)
        var denomX = (cw - sw);
        var denomY = (ch - sh);

        // If there is no horizontal crop, do not overwrite X
        if (0 !== denomX) {

            // Declare and initialize
            var px = (left / denomX);

            // Clamp
            px = Math.min(1, Math.max(0, px));

            // Write X
            wrap.style.setProperty('--focus-point-x', (px * 100).toFixed(2) + '%');

        }

        // If there is no vertical crop, do not overwrite Y
        if (0 !== denomY) {

            // Declare and initialize
            var py = (top / denomY);

            // Clamp
            py = Math.min(1, Math.max(0, py));

            // Write Y
            wrap.style.setProperty('--focus-point-y', (py * 100).toFixed(2) + '%');

        }

        // Prevent leaks
        return;
    }
}

export default FocalPrecision;